// @ts-nocheck
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Dialog } from "react-vant";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";

export default function OrderList({
  closeorder,
  addnumFun,
  strutcnumFun,
  editLossWinFun,
  coinListData,
  orderindex,
  setorderindex,
  leverorders,
  nowTab,
}) {
  const navigate = useNavigate();
  const tab = nowTab.toUpperCase() + "/USDT";
  const { t: translate } = useTranslation();
  //加 减 改
  const [tempData, settempData] = useState({} as any);
  const [addnum, setaddnum] = useState("");
  const [addnumVisible, setaddnumVisible] = useState(false);
  const [strutcnum, setstrutcnum] = useState("");
  const [strutcnumVisible, setstrutcnumVisible] = useState(false);
  const [lossnum, setlossnum] = useState("");
  const [winnum, setwinnum] = useState("");
  const [editLossWinVisible, seteditLossWinVisible] = useState(false);

  const getboomPrice = (type, bsnum) => {
    const openPrice = coinListData[nowTab]?.close;
    let price = 0;
    if (type == 1) {
      price = openPrice * (1 - 1 / bsnum + 0.005);
    }
    if (type == 2) {
      price = openPrice * (1 + 1 / bsnum - 0.005);
    }
    return price;
  };

  const getArray = () => {
    const nodes = [];
    leverorders = leverorders.filter((data) => data.coinname === tab);
    leverorders = leverorders.filter(
      (data) => data.status === orderindex-1
    );
    for (const i in leverorders) {
      const data = leverorders[i];
      const isPositive = (data.tzfx === 1 ? 1 : -1) * (coinListData[nowTab]?.close - data.openprice) > 0;
      nodes.push(
        <div key={i} className="bg-neutral-700/30 rounded-lg p-3 mb-2">
          <div className="flex justify-between items-center mb-2">
            <div className="flex items-center">
              <span className={`text-sm font-medium py-1 px-2 rounded ${data.tzfx === 1 ? 'bg-green-500/20 text-green-500' : 'bg-red-500/20 text-red-500'}`}>
                {data.tzfx === 1 ? translate(getText("看漲")) : translate(getText("看跌"))}
              </span>
              <span className="text-neutral-400 text-xs ml-2">x{data.leverage}</span>
            </div>
            <div className="flex items-center">
              <span className="text-xs text-neutral-400 mr-2">{data.createtime}</span>
              <button
                className="text-primary text-sm font-medium"
                onClick={() => {
                  Dialog.confirm({
                    title: translate(getText("确认平仓")),
                    message: translate(getText("确认要平仓吗")),
                    onConfirm: () => {
                      closeorder(data.id, data.amount, 0);
                    },
                  });
                }}
              >
                {translate(getText("平仓"))}
              </button>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4 mb-3">
            <div>
              <p className="text-neutral-400 text-xs mb-1">{translate(getText("开仓价"))}</p>
              <p className="text-white font-medium">{data.openprice}</p>
            </div>
            <div>
              <p className="text-neutral-400 text-xs mb-1">{translate(getText("当前价"))}</p>
              <p className="text-white font-medium">{coinListData[nowTab]?.close}</p>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4 mb-3">
            <div>
              <p className="text-neutral-400 text-xs mb-1">{translate(getText("数量"))}</p>
              <p className="text-white font-medium">{data.amount} USDT</p>
            </div>
            <div>
              <p className="text-neutral-400 text-xs mb-1">{translate(getText("止盈/止损"))}</p>
              <div className="flex items-center">
                <p className="text-white font-medium">{data.win} / {data.loss}</p>
                <button
                  className="ml-2 text-xs text-primary"
                  onClick={() => {
                    settempData(data);
                    setlossnum(data.loss);
                    setwinnum(data.win);
                    seteditLossWinVisible(true);
                  }}
                >
                  {translate(getText("修改"))}
                </button>
              </div>
            </div>
          </div>
          
          <div>
            <p className="text-neutral-400 text-xs mb-1">{translate(getText("收益"))}</p>
            <p className={`text-lg font-bold ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
              {((data.tzfx === 1 ? 1 : -1) * (coinListData[nowTab]?.close - data.openprice) * data.amount * data.leverage).toFixed(2)} USDT
            </p>
          </div>
          
          <div className="flex mt-3 space-x-2">
            <button
              className="flex-1 py-2 rounded-lg bg-neutral-600 text-white text-sm"
              onClick={() => {
                settempData(data);
                setaddnum("");
                setaddnumVisible(true);
              }}
            >
              {translate(getText("加仓"))}
            </button>
            <button
              className="flex-1 py-2 rounded-lg bg-neutral-600 text-white text-sm"
              onClick={() => {
                settempData(data);
                setstrutcnum("");
                setstrutcnumVisible(true);
              }}
            >
              {translate(getText("减仓"))}
            </button>
          </div>
        </div>
      );
    }
    return nodes;
  };

  return (
    <div className="p-3">
      <div className="flex gap-2 bg-neutral-700 rounded-lg p-1 mb-3">
        <button
          className={`flex-1 py-2 px-3 text-center rounded-md text-sm transition-colors 
            ${
              orderindex === 1
                ? "bg-primary text-black"
                : "text-neutral-400 hover:text-white"
            }`}
          onClick={() => setorderindex(1)}
        >
          {translate(getText("持倉"))}
        </button>
        <button
          className={`flex-1 py-2 px-3 text-center rounded-md text-sm transition-colors 
            ${
              orderindex === 2
                ? "bg-primary text-black"
                : "text-neutral-400 hover:text-white"
            }`}
          onClick={() => setorderindex(2)}
        >
          {translate(getText("已成交"))}
        </button>
      </div>

      <div className="overflow-y-auto max-h-[400px]">{getArray()}</div>

      {/* 加仓弹窗 */}
      <Dialog
        visible={addnumVisible}
        title={translate(getText("加仓"))}
        showCancelButton
        onConfirm={() => {
          if (!addnum) return;
          addnumFun({
            id: tempData.id,
            amount: addnum,
          });
          setaddnumVisible(false);
        }}
        onCancel={() => setaddnumVisible(false)}
      >
        <div className="p-4">
          <input
            value={addnum}
            onChange={(e) => setaddnum(e.target.value)}
            placeholder={translate(getText("请输入加仓金额"))}
            className="w-full p-2 border border-neutral-400 rounded focus:outline-none focus:border-primary"
            type="number"
          />
        </div>
      </Dialog>

      {/* 减仓弹窗 */}
      <Dialog
        visible={strutcnumVisible}
        title={translate(getText("减仓"))}
        showCancelButton
        onConfirm={() => {
          if (!strutcnum) return;
          strutcnumFun({
            id: tempData.id,
            amount: strutcnum,
          });
          setstrutcnumVisible(false);
        }}
        onCancel={() => setstrutcnumVisible(false)}
      >
        <div className="p-4">
          <input
            value={strutcnum}
            onChange={(e) => setstrutcnum(e.target.value)}
            placeholder={translate(getText("请输入减仓金额"))}
            className="w-full p-2 border border-neutral-400 rounded focus:outline-none focus:border-primary"
            type="number"
          />
        </div>
      </Dialog>

      {/* 止盈止损弹窗 */}
      <Dialog
        visible={editLossWinVisible}
        title={translate(getText("修改止盈止损"))}
        showCancelButton
        onConfirm={() => {
          if (!lossnum || !winnum) return;
          editLossWinFun({
            id: tempData.id,
            loss: lossnum,
            win: winnum,
          });
          seteditLossWinVisible(false);
        }}
        onCancel={() => seteditLossWinVisible(false)}
      >
        <div className="p-4 space-y-4">
          <div>
            <label className="block text-sm text-neutral-500 mb-1">
              {translate(getText("止损"))}
            </label>
            <input
              value={lossnum}
              onChange={(e) => setlossnum(e.target.value)}
              placeholder={translate(getText("请输入止损价"))}
              className="w-full p-2 border border-neutral-400 rounded focus:outline-none focus:border-primary"
              type="number"
            />
          </div>
          <div>
            <label className="block text-sm text-neutral-500 mb-1">
              {translate(getText("止盈"))}
            </label>
            <input
              value={winnum}
              onChange={(e) => setwinnum(e.target.value)}
              placeholder={translate(getText("请输入止盈价"))}
              className="w-full p-2 border border-neutral-400 rounded focus:outline-none focus:border-primary"
              type="number"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
